import { render, staticRenderFns } from "./importexport-element.vue?vue&type=template&id=3b2e780a&"
import script from "./importexport-element.vue?vue&type=script&lang=ts&"
export * from "./importexport-element.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports